import React from "react";
import sound from "../audio/backgroundMusic.mp3";
import { useEffect } from "react";
import { ReactComponent as Play } from "../images/play-button.svg";
import { ReactComponent as Pause } from "../images/pause.svg";
import "../css/audio.css";
function TheBackgroundMusic() {
  let playAudio = false;


  const audio = new Audio(sound);

  function play() {
    if (!playAudio) {
      audio.play();

    } else {
      audio.pause();
    }
    
    audio.addEventListener(
      "ended",
      function () {
        this.currentTime = 0;
        this.play();
      },
      false
    );
    
    playAudio = !playAudio;
  }

  let button;
  if (playAudio === true) {
    button = <Pause onClick={play} />;
  } else {
    button = <Play className='Playbtn' onClick={play} />;
  }



  return <div className="audio">{button}</div>;
}

export default TheBackgroundMusic;
